/**
 * Factory для створення menu items функції таблиці
 * 
 * Генерує контекстне меню для рядків таблиці з пунктами:
 * - Переглянути
 * - Редагувати
 * - Видалити (з підтвердженням)
 */

import React from 'react'
import { AiOutlineDelete } from 'react-icons/ai'
import { BiEdit, BiShowAlt } from 'react-icons/bi'
import { AddTableModeCrudFeature } from './constants'
import { DeleteMenuItemLabel } from './components'

/**
 * Створює функцію генерації menu items для таблиці
 * 
 * @param crudContext - контекст CRUD ресурсу з actions та accessFn
 * @returns функція, яка генерує меню для конкретного item
 */
export const createMenuItemsFunction = (crudContext: any) => {
    return ({ item }: { item: any }) => {
        const menuItems: any[] = []
        
        
        // Перевіряємо чи існує accessFn
        if (!crudContext.accessFn || typeof crudContext.accessFn !== 'function') {
            return menuItems
        }

        // Пункт меню "Переглянути"
        if (
            crudContext.accessFn({
                accessMode: 'read',
                accessItem: item,
                crudContext: crudContext,
            }) && 
            crudContext.actions?.view && 
            crudContext.settings?.AddDrawerModeCrudFeature?.enableMenuViewItem !== false
        ) {
            menuItems.push({
                icon: React.createElement(BiShowAlt, { style: { fontSize: 18 } }),
                label:
                    crudContext.settings?.AddDrawerModeCrudFeature?.menuViewItemText ??
                    AddTableModeCrudFeature.defaultTexts.view,
                onClick: () => crudContext.actions.view(item),
                key: 'view',
                sort: 100,
            })
        }

        // Пункт меню "Редагувати"
        if (
            crudContext.accessFn({
                accessMode: 'update',
                accessItem: item,
                crudContext: crudContext,
            }) && 
            crudContext.actions?.edit && 
            crudContext.settings?.AddDrawerModeCrudFeature?.enableMenuEditItem !== false
        ) {
            menuItems.push({
                icon: React.createElement(BiEdit, { style: { fontSize: 18 } }),
                onClick: () => crudContext.actions.edit(item),
                label:
                    crudContext.settings?.AddDrawerModeCrudFeature?.menuEditItemText ??
                    AddTableModeCrudFeature.defaultTexts.edit,
                key: 'edit',
                sort: 200,
            })
        }

        // Пункт меню "Видалити"
        if (
            crudContext.accessFn({
                accessMode: 'delete',
                accessItem: item,
                crudContext: crudContext,
            }) && 
            crudContext.actions?.delete && 
            crudContext.settings?.AddDrawerModeCrudFeature?.enableMenuDeleteItem !== false &&
            crudContext?.resource?.settings?.AddDrawerModeCrudFeature?.enableMenuDeleteItem !== false
        ) {
            menuItems.push({
                icon: React.createElement(AiOutlineDelete, { style: { fontSize: 18 } }),
                danger: true,
                label: React.createElement(DeleteMenuItemLabel, {
                    text:
                        crudContext.settings?.AddDrawerModeCrudFeature?.menuDeleteItemText ??
                        AddTableModeCrudFeature.defaultTexts.delete,
                    confirmDescription:
                        crudContext.settings?.AddDrawerModeCrudFeature?.menuDeleteConfirmItemText ??
                        undefined,
                    onConfirm: () => crudContext.actions.delete(item),
                }),
                key: 'delete',
                sort: 300,
            })
        }

        // Додаємо кастомні menu items через подію
        if (crudContext.eventManager) {
            crudContext.eventManager.emit('onTableMenuItemsBuild', { menuItems, item, crudContext })
        }
        
        // Сортуємо за полем sort
        menuItems.sort((a, b) => (a.sort || 0) - (b.sort || 0))
        
        return menuItems
    }
}
